//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';

export default {
  props: {
    activity: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    format(data) {
      if (!data) return '-';
      return dayjs(new Date(data)).format('YYYY-MM-DD');
    }
  }
};
